<template>
  <div>
    <el-button type="primary" style="margin-left: 10px" @click="exportOrderSku">
      批量导出订单商品
    </el-button>
    <el-dialog
      width="400px"
      title="导出订单商品数据"
      :visible="showExportOrderSkuVisible"
      @close="showExportOrderSkuVisible = false"
    >
      <el-form :inline="true" :model="exportOrderSkuForm">
        <el-form-item label="订单号">
          <el-input
            type="textarea"
            autosize
            v-model="exportOrderSkuForm.merchantOrderNoList"
            placeholder="请输入订单号,多个单号以回车换行"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showExportOrderSkuVisible = false">取消</el-button>
        <el-button type="primary" @click="doExportOrderSku">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import danding from "@/api/danding";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      showExportOrderSkuVisible: false,
      exportOrderSkuForm: {
        merchantOrderNoList: "",
      },
    };
  },
  methods: {
    exportOrderSku() {
      this.showExportOrderSkuVisible = true;
    },
    async doExportOrderSku() {
      const merchantOrderNoList = this.exportOrderSkuForm.merchantOrderNoList;
      const list = merchantOrderNoList.split("\n");
      await this.exportSkuByMerchantOrderNoList(list.map((l) => l.trim()));
      this.$message.success("导出成功");
      this.showExportOrderSkuVisible = false;
      this.exportOrderSkuForm.merchantOrderNoList = "";
    },
    async exportSkuByMerchantOrderNoList(merchantOrderNoList) {
      const data = [
        [
          "货主ID",
          "运单号",
          "订单号",
          "商品名称",
          "数量",
          "料号",
          "单价",
          "条码",
          "hscode",
          "账册号",
          "净重",
          "毛重",
          "创建时间",
        ],
      ];
      const res = await danding.querySkuByMerchantOrderNoList({
        request: {
          merchantOrderNoList: merchantOrderNoList,
        },
      });
      res.items.forEach((item) => {
        data.push([
          item.customerId,
          item.mailNo,
          item.merchantOrderNo,
          item.skuName,
          item.quantity,
          item.itemNo,
          item.price,
          item.barcode,
          item.hsCode,
          item.accountBookNo,
          item.netWeight,
          item.grossWeight,
          item.gmtCreate,
        ]);
      });
      let workSheet = "";
      await (workSheet = XLSX.utils.aoa_to_sheet(data));
      let workBook = XLSX.utils.book_new();
      await XLSX.utils.book_append_sheet(workBook, workSheet, "1");
      await XLSX.writeFile(workBook, "订单商品数据导出.xlsx");
    },
  },
};
</script>
